import { motion } from 'framer-motion';
import React from 'react';

const fadeInUp = (duration: number, delay: number) => ({
  hidden: {
    opacity: 0,
    y: 40,
  },
  show: {
    opacity: 1,
    transition: {
      delay,
      duration,
      ease: [0.25, 0.25, 0.25, 0.75],
      type: 'tween',
    },
    y: 0,
  },
});

type FadeInUpItemProps = {
  children: React.ReactNode;
  delay?: number;
  duration?: number;
};

export const FadeInUpItem: React.FC<FadeInUpItemProps> = ({
  children,
  duration = 0.8,
  delay = 0.3,
}) => (
  <motion.div
    variants={fadeInUp(duration, delay)}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true }}
  >
    {children}
  </motion.div>
);
